export const membershipDetailsSelector = (state) => {
    var _a, _b;
    return state.user.status.is_owner
        ? state.user.status.membership_details
        : (_b = (_a = state.user.ownerStatus) === null || _a === void 0 ? void 0 : _a.membership_details) !== null && _b !== void 0 ? _b : null;
};
export const mobileSelector = (state) => state.user.status.mobile;
export const mobileUnconfirmedSelector = (state) => state.user.status.mobile_unconfirmed;
export const isFreSelector = (state) => { var _a, _b; return state.user.status.is_owner ? state.user.status.is_fre : (_b = (_a = state.user.ownerStatus) === null || _a === void 0 ? void 0 : _a.is_fre) !== null && _b !== void 0 ? _b : null; };
export const userIdSelector = (state) => state.user.status.user_id;
export const userPrivacySettingsSelector = (state) => state.user.status.data_opt_out;
export const userEmailSelector = (state) => state.user.status.email;
export const isOwnerSelector = (state) => !!state.user.status.is_owner;
export const isReadOnlyOwnerSelector = (state) => !!state.user.status.is_read_only_owner;
export const isCaregiverSelector = (state) => !!state.user.status.is_caregiver;
export const isReadOnlyCaregiverSelector = (state) => !!state.user.status.is_read_only_caregiver;
export const hasCompletedAdminCaregiverSetupSelector = (state) => !state.user.status.unfinished_admin_caregiver_setup;
export const isUserLoadingSelector = (state) => state.user.isLoading;
export const selectedAccountIdSelector = (state) => state.user.status.selected_account_id;
export const hasCaregiverAccountsSelector = (state) => { var _a; return !!((_a = state.user.status.caregiver_details) === null || _a === void 0 ? void 0 : _a.length); };
export const isUserStatusErrorSelector = (state) => {
    return state.user.error;
};
//# sourceMappingURL=selectors.js.map